<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                  <FormSection title="Your Details">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                      <Consent privacy="https://ncsy.org/privacy-policy/"/>
                  </FormRow>                        
                  </FormSection>                
                  <FormSection title="Billing Information" >
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="">
                      <FormRow>
                          <FormLabel class="control-label">
                            Notes
                        </FormLabel>
                      </FormRow>									
                      <FormRow>
                        <FormInput type="textarea" class="width-half" field="custom.Notes"/>                      
                      </FormRow> 
                  </FormSection>    
                  <FormSection title="Payment Plan">
                    <div class="frequency">
                      <PaymentOptions 
                      oneTimeText="Pay in Full" addSplit splitText="Split Payment"/>
                    </div>
                  </FormSection>                              
                  <FormSection title="Payment Information" last>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false" />
                      </FormRow>
                   </FormSection>
                  <PaymentButton showAmount btnText="Donate"/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>
  <script lang="ts">
  import {
    computed,
    defineComponent,
  onMounted,
    ref,
    watch
  } from 'vue'
  import { usePaymentForm } from '~/shared/use-payment-form'
  
  export default defineComponent({
    setup() {
      const { getValue, settings, setValue, form } = usePaymentForm()
  

      setValue('amount', '1840');
      setValue('custom.designation', '18forty-innovations');
      const amountSelector = ref()
  
  
      return {
        getValue,
        form
              }
    },
  });
  </script>
  
  <style scoped lang="scss">
  
  ::v-deep .styled-radio.styled-radio--ou-donation.row{
    .vs__search, .vs__search:focus {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none !important;
        line-height: 1.85;
        font-size: 1em;
        border: 1px solid transparent !important;
        border-left: none !important;
        outline: none !important;
        margin: 4px 0 0 !important;
        padding: 0 7px !important;
        background: none !important;
        box-shadow: none;
        width: 0 !important;
        max-width: 100%;
        flex-grow: 1;
    }
  
    .currency-selector ::v-deep .v-select {
    background: #f7f9fb;
    height: 42px;
  
    .vs__dropdown-toggle {
      border-color: #ddd;
    }
  }
  
  }
  
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }
  .frequency{
    margin-top: 20px;
  }
  .sponsorships {
    display: flex;
    width: 100%;
    ::v-deep select {
      flex: 1;
      min-width:32%;
      max-width:33%;
      margin-right: 1%;
    }
    ::v-deep select:last-child {
      margin-right: 0;
    }
  }
  label.sponsorhip__label{
      width: 100%;
    ::v-deep select {
       margin-top: 8px;
       width: 100%;
    }
  }
  .inquired__episode{
        font-style: italic;
      margin-top: -6px;
      font-size: 15px;
      display: block;
  }
  .availiable__episode{
      font-weight:bold;
      margin-top: -6px;
      font-size: 16px;
  }
  .sponsor__section{
    ::v-deep h2{
      margin-bottom: 5px;
    }
    h4{
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 15px;
    }
  
  }
  
  .sponsorhip__topic{
     margin-top: 25px;
  }
  </style>
  
  